import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/broadcastSchedule")({
  beforeLoad: () => {
    throw redirect({ to: "/explore" });
  },
});
